
import { mapState } from 'vuex'

export default {
  name: 'TheHeader',
  data: () => ({
    displayMenu: false
  }),
  computed: {
    ...mapState({
      imageUrl: (state) => state.menu.imageUrl
    })
  },
  watch: {
    $route() {
      this.displayMenu = false
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 2) this.$router.go(-1)
      else this.$router.push(this.localePath('/'))
    }
  }
}
